import { Form } from '@shared';
import styled from 'styled-components';

export const AuthForm = styled(Form).attrs({ alignItems: 'center' })``;
